<template>
  <section v-editable="cms" :class="[name, spacing]" :style="mainCssVars">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: getRows,
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          rows: getRows,
          gap: '10px',
        },
      ]"
    >
      <grid-item
        v-if="leftQuote"
        :reverse="reverse"
        :class="[
          `${name}__grid-item`,
          `${name}__quote`,
          `${name}__quote--left`,
          leftQuote,
        ]"
        :layout="[
          { size: 1, x: 1, width: 2, y: 1 },
          { size: 3, x: 3, width: 4, y: 1 },
          { size: 4, x: 8, width: 2, y: 1 },
        ]"
      >
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 3, width: 8, y: 2 },
          { size: 3, x: 5, width: 14, y: 2 },
          { size: 4, x: 10, width: 10, y: 2 },
        ]"
      >
        <a-copy :class="[`${name}__text`, `${name}__quotation`]" :cms="cms" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="cms.citation"
          :class="[`${name}__text`, `${name}__citation`]"
          v-html="$options.filters.markdown(cms.citation)"
        />
        <!--eslint-enable-->
      </grid-item>
      <grid-item
        v-if="rightQuote"
        :reverse="reverse"
        :class="[
          `${name}__grid-item`,
          `${name}__quote`,
          `${name}__quote--right`,
          rightQuote,
        ]"
        :layout="[
          { size: 1, x: 11, width: 2, y: 3 },
          { size: 3, x: 19, width: 4, y: 3 },
          { size: 4, x: 20, width: 2, y: 3 },
        ]"
      >
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-quote-v2.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-quote-v2',
    }
  },

  computed: {
    reverse() {
      return this.cms.reverse || false
    },
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
    leftQuote() {
      return this.cms.quote_left
    },
    rightQuote() {
      return this.cms.quote_right
    },
    getRows() {
      if (this.cms.quote_left && this.cms.quote_right) {
        return '100px auto 100px'
      } else if (this.cms.quote_left) {
        return '100px auto'
      } else if (this.cms.quote_right) {
        return 'auto 100px'
      }
      return ''
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || 'transparent',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--quote-color': this.setColor(
          (this.cms.color_quote || {}).color || '#000000'
        ),
        '--quote-size': this.cms.quote_size || '102px',
        '--spacing-top': this.cms.spacing_top || '30px',
        '--spacing-bottom': this.cms.spacing_bottom || '30px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-article-quote-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  // background: transparent;
  padding: var(--spacing-top) 0 var(--spacing-bottom);
  background: var(--bg-color);
  color: var(--text-color);

  &__grid {
    position: relative;
  }

  &__quote {
    @include font-family($headings-font-family, 600);

    font-size: var(--quote-size);
    color: var(--quote-color);
    line-height: 1;
    position: relative;

    &--left {
      &.single_quote::after {
        content: '‘';
      }
      &.double_quote::after {
        content: '“';
      }
      &.single_quote::after,
      &.double_quote::after {
        height: 100%;
        display: block;
        position: absolute;
        bottom: -20px;
      }
    }
    &--right {
      &.single_quote::after {
        content: '’';
      }
      &.double_quote::after {
        content: '”';
      }
      &.single_quote::after,
      &.double_quote::after {
        height: 100%;
        display: block;
        position: absolute;
        top: -20px;
      }
    }
  }

  &__content {
    align-self: center;
  }

  &__quotation {
    ::v-deep > * {
      letter-spacing: 1px;
      line-height: 1.7;
      margin: 0 0 20px;
    }
  }
  &__citation {
    ::v-deep > * {
      @include font-size(14, 24px);
    }
  }
}

@include media-breakpoint-up(md) {
  .m-article-quote-v2 {
    &__grid {
      grid-row-gap: 0;
    }
    &__quote {
      &--left {
        &.single_quote::after,
        &.double_quote::after {
          bottom: -30px;
        }
      }
      &--right {
        &.single_quote::after,
        &.double_quote::after {
          top: -30px;
        }
      }
    }
  }
}
</style>
